import styled from 'styled-components';
import TextField from '@mui/material/TextField';
import { theme } from '../style';

export const StyledTextField = styled(TextField)`
  width: 100%;

  & label {
    color: rgba(0, 0, 0, 0.6) !important;
  }

  & label.Mui-focused {
    color: ${theme.colors.grey.v7};
  }

  & .MuiInput-underline:after {
    border-bottom-color: ${theme.colors.grey.v7};
  }

  & .MuiOutlinedInput-root {
    &.MuiInputBase-root {
      background-color: ${theme.colors.grey.v1};
      &.Mui-error {
        background-color: #f8dcdc;
      }
    }

    & fieldset {
      border: 2px solid ${theme.colors.grey.v2} !important;
      transition: all 0.2s;
    }

    &:hover fieldset {
      border-color: ${theme.colors.grey.v5} !important;
    }

    &.Mui-focused fieldset {
      border-color: ${theme.colors.grey.v7} !important;
    }

    &.Mui-error {
      & fieldset {
        border: 2px solid #d32f2f !important;
        transition: all 0.2s;
      }

      &:hover fieldset {
        border-color: #d32f2f !important;
      }

      &.Mui-focused fieldset {
        border-color: #d32f2f !important;
      }
    }

    input {
      -webkit-text-fill-color: ${theme.colors.grey.v7};
    }
  }

  .MuiSelect-select {
    &.MuiSelect-outlined {
      text-align: center;
    }
  }
`;
